import Api from '../../../axios'
import { callLoader, ACTION_APP_SESSION } from '../../../common/actions/app'

let callLoginPost = (data, callback = () => { }) => (dispatch) => {
    dispatch(callLoader(true))
    Api.post('/auth', data).then(data => {
        dispatch(callLoader(false))
        if (!data)
            return;

        ACTION_APP_SESSION.payload.logged = data.logged
        ACTION_APP_SESSION.payload.name = data.name
        ACTION_APP_SESSION.payload.profile = data.profile
        dispatch(ACTION_APP_SESSION)

        callback()
    })
}

export { callLoginPost }